import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TranslationContext } from '../../../../assets/contexts/translationContext';
import { MOCK_DEPOSIT } from '../../../../assets/constants/depositData';
import { cancelDepositFlow, clearDepositSession, getDepositSession } from '../../../../assets/services/deposit';
import { triggerImpactHaptic } from '../../../../assets/utils/hapticFeedback';
import ScreenHeader from '../../../ScreenHeader/ScreenHeader';
import './DepositFailed.css';

function DepositFailed() {
  const navigate = useNavigate();
  const { common, deposit } = useContext(TranslationContext);
  const session = getDepositSession();

  useEffect(() => {
    if (session?.status !== 'failed') {
      navigate('/deposit', { replace: true });
    }
  }, [navigate, session?.status]);

  const handleBackHome = () => {
    cancelDepositFlow();
    clearDepositSession();
    navigate('/home');
  };
  const handleBackHomeButton = () => {
    triggerImpactHaptic('light');
    handleBackHome();
  };

  return (
    <section className="deposit-failed">
      <ScreenHeader title={deposit.topUpCard} onBack={handleBackHome} />

      <div className="deposit-failed__icon" aria-hidden="true">
        ×
      </div>

      <h2 className="deposit-failed__title">{deposit.topUpFailed}</h2>
      <p className="deposit-failed__subtitle">{deposit.topUpFailedText}</p>

      <div className="deposit-failed__alert">
        <span className="deposit-failed__alert-icon" aria-hidden="true">
          !
        </span>
        <p className="deposit-failed__alert-text">
          {session?.reason ?? MOCK_DEPOSIT.failureReason}
        </p>
      </div>

      <button type="button" className="deposit-failed__support">
        {common.contactSupport}
      </button>

      <button type="button" className="deposit-failed__back-home" onClick={handleBackHomeButton}>
        {common.backToHome}
      </button>
    </section>
  );
}

export default DepositFailed;
